import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface SankeyChartProps {
  nodes: Array<{ name: string }>;
  links: Array<{ source: string; target: string; value: number }>;
  height?: number | string;
  loading?: boolean;
}

export function SankeyChart({ nodes, links, height, loading }: SankeyChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'item' },
    series: [{ type: 'sankey', emphasis: { focus: 'adjacency' }, nodeWidth: 20, nodeGap: 8, data: nodes, links } as any],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
